import { SET_WAIVER_FORMS, SET_WAIVER_FORM_FIELD } from './actionTypes'

export const setWaiverForms = waiverForms => {
  return {
    type: SET_WAIVER_FORMS,
    waiverForms
  }
}

export const setWaiverFormField = ({ waiverType, fieldName, fieldValue }) => {
  return {
    type: SET_WAIVER_FORM_FIELD,
    waiverType,
    fieldName,
    fieldValue
  }
}
